import {
  createFetchWithClerk,
  createFetchMe,
} from "@the-drop/customer-shared/api/fetch-with-clerk";
import { getCustomerApiBaseUrl } from "./api-base";

export const fetchWithClerkJwt = createFetchWithClerk({
  getBaseUrl: getCustomerApiBaseUrl,
});

export const fetchMe = createFetchMe(fetchWithClerkJwt);

export {
  FetchMeHttpError,
  formatMeFetchError,
  type MeResponse,
} from "@the-drop/customer-shared/api/fetch-with-clerk";
